import React from 'react';
import { Flashbar, FlashbarProps, Link } from '@cloudscape-design/components';
import { useNavigate } from 'react-router-dom';

interface WhatsNewBannerProps {
  onDismiss: () => void;
  message?: string | React.ReactElement;
}

export const WhatsNewBanner: React.FC<WhatsNewBannerProps> = ({ onDismiss, message }) => {
  const navigate = useNavigate();

  const handleLinkClick = () => {
    const whatsNewSection = document.getElementById('whats-new-section');
    if (whatsNewSection) {
      whatsNewSection.scrollIntoView({ behavior: 'smooth' });
    } else {
      navigate('/', { replace: true });
      setTimeout(() => {
        const element = document.getElementById('whats-new-section');
        if (element) {
          element.scrollIntoView({ behavior: 'smooth' });
        }
      }, 100);
    }
  };

  const defaultContent = (
    <>
      New features available! <Link onFollow={handleLinkClick}>Check out What's New</Link>{' '}
      for details.
    </>
  );

  const items: FlashbarProps.MessageDefinition[] = [
    {
      type: 'info',
      dismissible: true,
      onDismiss,
      content: message || defaultContent,
      id: 'whats-new-notification',
      ariaRole: 'status',
    },
  ];

  return <Flashbar items={items} />;
};
